import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { v4 as uuidv4 } from 'uuid';
import { utilCookies } from '@/util/cookies';
import ExcelUpload from './excel-upload.vue';
export default {
  name: 'BatchImportDialog',
  components: {
    ExcelUpload: ExcelUpload
  },
  // 关闭属性自动挂载到根元素，避免 $attrs 混入 el-dialog 的根节点
  inheritAttrs: false,
  data: function data() {
    return {
      /** @type {boolean} 内部可见性，关闭时置 false，动画结束后 emit close */
      innerVisible: true,
      /** @type {boolean} 是否正在提交（上传 + 导入 + 轮询全过程） */
      submitting: false,
      /** @type {boolean} handleRequest 执行期间是否显示加载状态 */
      requestLoading: false,
      /** @type {boolean} 当前导入请求是否已经结束 */
      submitted: false,
      /** @type {boolean} 是否已选择文件 */
      hasFile: false
    };
  },
  computed: {
    /**
     * 转发给 ExcelUpload 的事件监听器
     * 内部先做状态维护，再统一 $emit 给父组件
     * @returns {Object}
     */
    excelUploadListeners: function excelUploadListeners() {
      return {
        change: this.handleChange,
        remove: this.handleRemove,
        success: this.handleSuccess,
        error: this.handleError,
        'request-start': this.handleRequestStart,
        'import-start': this.handleImportStart
      };
    }
  },
  methods: {
    /**
     * @description: 下载模板
     * @param {*} payload
     * @return {*}
     */
    doDownloadTemFn: function doDownloadTemFn(payload) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.requestLoading = true;
              _this.$http({
                url: '/web/attendance_import/getTemplate',
                method: 'GET',
                params: {
                  language: utilCookies.getLanguage()
                }
              }).then(function (res) {
                var _res$data;
                if (res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && _res$data.download_url) {
                  payload.open(res.data.download_url);
                }
              }).finally(function () {
                _this.requestLoading = false;
              });
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    /**
     * 提交考勤导入任务
     *
     * importProps 为 Function 时由该方法直接执行请求，返回值作为同步模式结果。
     *
     * @param {Object} context - 导入上下文
     * @param {File} context.file - 当前文件
     * @param {Object} context.credential - OSS 凭证
     * @returns {Promise<Object>}
     */
    submitAttendanceImport: function submitAttendanceImport(_ref) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var file, credential, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              file = _ref.file, credential = _ref.credential;
              _context2.next = 3;
              return _this2.$http({
                url: '/web/attendance_import/submit',
                method: 'POST',
                data: {
                  file_url: credential.objectUrl,
                  file_name: file.name,
                  request_id: uuidv4()
                }
              });
            case 3:
              res = _context2.sent;
              return _context2.abrupt("return", res && res.data !== undefined ? res.data : res);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    /**
     * 选择文件后同步「是否有文件」状态
     * @param {Object} file - 当前选中的文件
     * @param {Array<Object>} fileList - 最新文件列表
     * @fires BatchImportDialog#change
     * @private
     */
    handleChange: function handleChange(file, fileList) {
      this.hasFile = Array.isArray(fileList) && fileList.length > 0;
      this.$emit('change', file, fileList);
    },
    /**
     * 移除文件后同步「是否有文件」状态
     * @param {Object} file - 被移除的文件
     * @param {Array<Object>} fileList - 最新文件列表
     * @fires BatchImportDialog#remove
     * @private
     */
    handleRemove: function handleRemove(file, fileList) {
      this.hasFile = Array.isArray(fileList) && fileList.length > 0;
      this.$emit('remove', file, fileList);
    },
    /**
     * ExcelUpload 开始执行 handleRequest
     * @param {File} file - 当前文件
     * @fires BatchImportDialog#request-start
     * @private
     */
    handleRequestStart: function handleRequestStart(file) {
      this.requestLoading = true;
      this.$emit('request-start', file);
    },
    /**
     * OSS 上传完成、开始触发业务导入
     * 此刻锁定 submitting，禁止重复提交
     * @param {File} file - 当前文件
     * @fires BatchImportDialog#import-start
     * @private
     */
    handleImportStart: function handleImportStart(file) {
      // 上传链路真正开始，锁定 submitting
      this.submitting = true;
      this.$emit('import-start', file);
    },
    /**
     * 导入成功：解除提交锁定，切换底部按钮为「重新导入」
     * @param {Object} result - 标准结果结构 { successCount, failCount, failFileUrl? }
     * @param {File} file - 当前文件
     * @fires BatchImportDialog#success
     * @private
     */
    handleSuccess: function handleSuccess(result, file) {
      this.submitting = false;
      this.requestLoading = false;
      this.submitted = true;
      this.$emit('success', result, file);
    },
    /**
     * 导入失败：解除提交锁定，恢复底部「导入」按钮
     * @param {Error} err - 错误对象
     * @param {File} file - 当前文件
     * @fires BatchImportDialog#error
     * @private
     */
    handleError: function handleError(err, file) {
      this.submitting = false;
      this.requestLoading = false;
      this.submitted = false;
      this.$emit('error', err, file);
    },
    /* ============ 底部按钮 ============ */
    /**
     * 点击「确认导入」：触发 ExcelUpload 的上传流程
     *
     * 先置 `submitting=true` 立即锁定按钮，再在 `$nextTick` 中调用
     * `ref.submit()`，避免 el-upload 内部文件状态尚未就绪时提交。
     *
     * @returns {void}
     * @private
     */
    handleConfirm: function handleConfirm() {
      var _this3 = this;
      if (!this.hasFile || this.submitting) return;
      this.submitting = true;
      this.$nextTick(function () {
        if (_this3.$refs.excelUploadRef) {
          _this3.$refs.excelUploadRef.submit();
        }
      });
    },
    /**
     * 清空本次导入数据，恢复初始导入状态
     * @returns {void}
     * @private
     */
    handleReimport: function handleReimport() {
      this.clearFiles();
    },
    /**
     * 关闭弹窗，关闭动画结束后由 handleClosed 通知父组件
     * @returns {void}
     * @private
     */
    doCancelFn: function doCancelFn() {
      this.$emit('cancel');
      this.innerVisible = false;
    },
    /**
     * el-dialog 关闭动画结束：通知父组件销毁（v-if 置 false）
     * @returns {void}
     * @fires BatchImportDialog#close
     * @private
     */
    handleClosed: function handleClosed() {
      this.$emit('close');
    },
    /**
     * 清空文件与结果
     * @returns {void}
     */
    clearFiles: function clearFiles() {
      if (this.$refs.excelUploadRef) {
        this.$refs.excelUploadRef.clearFiles();
      }
      this.hasFile = false;
      this.submitting = false;
      this.requestLoading = false;
      this.submitted = false;
    }
  }
};